<template>
	<span>
		<v-navigation-drawer
			id="app-nav-drawer"
			app
			v-model="drawer"
			disable-resize-watcher
			color="#0C1D40"
			dark
		>
			<!-- Nav Dropdown (tablet/smartphones) -->
			<v-list shaped>
				<v-list-item v-for="(item, i) in items" :key="i">
					<font-awesome-icon :icon="item.icon" />
					<v-list-item-content>
						<router-link class="dropdown-text" v-bind:to="item.to">
							{{ item.title }}</router-link
						>
					</v-list-item-content>
				</v-list-item>
			</v-list>
			<v-divider></v-divider>
			<v-list shaped v-if="!isAuthenticated">
				<v-list-item
					v-for="(item, i) in authMenuItemsNonAuthed"
					:key="i"
					v-on:click="menuEventHandler(item.title)"
				>
					<v-list-item-content>
						<router-link v-bind:to="item.to">{{
							item.title
						}}</router-link>
					</v-list-item-content>
				</v-list-item>
			</v-list>
			<v-list shaped v-if="isAuthenticated && !isAdmin">
				<v-list-item
					v-for="(item, i) in authMenuItemsNonAdmin"
					:key="i"
					v-on:click="menuEventHandler(item.title)"
				>
					<v-list-item-content>
						<router-link v-bind:to="item.to">{{
							item.title
						}}</router-link>
					</v-list-item-content>
				</v-list-item>
			</v-list>
			<v-list shaped v-if="isAuthenticated && isAdmin">
				<v-list-item
					v-for="(item, i) in authMenuItemsAdmin"
					:key="i"
					v-on:click="menuEventHandler(item.title)"
				>
					<v-list-item-content>
						<router-link v-bind:to="item.to">{{
							item.title
						}}</router-link>
					</v-list-item-content>
				</v-list-item>
			</v-list>
		</v-navigation-drawer>

		<!-- App Nav Bar (desktop) -->
		<v-app-bar app flat height="64px" id="app-bar">
			<font-awesome-icon
				:icon="['fal', 'bars']"
				class="hidden-md-and-up dropdown-trigger-icon"
				@click="drawer = !drawer"
			/>
			<div class="hidden-md-and-down text-white">
				<span class="logo pr-1">ICBEM 2022</span>
			</div>
			<v-spacer class="hidden-md-and-up"></v-spacer>
			<v-toolbar-title
				class="hidden-lg-and-up"
				style="color: var(--text-color-white);"
				>ICBEM 2022</v-toolbar-title
			>
			<v-spacer></v-spacer>
			<!-- Toolbar Menu Items -->
			<span class="toolbar-wrapper hidden-sm-and-down">
				<v-container>
					<v-layout align-center justify-end row fill-height>
						<v-flex v-for="item in items" v-bind:key="item.title">
							<router-link
								class="toolbar-link"
								v-bind:to="item.to"
								exact-active-class="active"
								>{{ item.title }}</router-link
							>
						</v-flex>
						<!-- <v-flex>
							<template>
								<div class="text-center">
									<v-menu open-on-hover offset-y>
										<template v-slot:activator="{ on }">
											<font-awesome-icon
												:icon="['fal', 'user-circle']"
												class="account-nav-icon"
												v-on="on"
											/>
										</template>
										<v-list
											v-if="isAuthenticated && isAdmin"
											class="account-nav-menu"
										>
											<v-list-item
												v-for="(item,
												index) in dropMenuItemsAdmin"
												:key="index"
												v-on:click="
													menuEventHandler(item.title)
												"
											>
												<v-list-item-title
													><router-link
														v-bind:to="item.to"
														enabled="item.enabled"
														class="account-nav-menu-item"
														>{{
															item.title
														}}</router-link
													></v-list-item-title
												>
											</v-list-item>
										</v-list>
										<v-list
											v-if="isAuthenticated && !isAdmin"
											class="account-nav-menu"
										>
											<v-list-item
												v-for="(item,
												index) in dropMenuItemsNonAdmin"
												:key="index"
												v-on:click="
													menuEventHandler(item.title)
												"
											>
												<v-list-item-title
													><router-link
														v-bind:to="item.to"
														enabled="item.enabled"
														class="account-nav-menu-item"
														>{{
															item.title
														}}</router-link
													></v-list-item-title
												>
											</v-list-item>
										</v-list>
										<v-list
											v-if="!isAuthenticated"
											class="account-nav-menu"
										>
											<v-list-item
												v-for="(item,
												index) in dropMenuItemsNonAuthed"
												:key="index"
												v-on:click="
													menuEventHandler(item.title)
												"
											>
												<v-list-item-title
													><router-link
														v-bind:to="item.to"
														enabled="item.enabled"
														class="account-nav-menu-item"
														>{{
															item.title
														}}</router-link
													></v-list-item-title
												>
											</v-list-item>
										</v-list>
									</v-menu>
								</div>
							</template>
						</v-flex> -->
					</v-layout>
				</v-container>
			</span>
		</v-app-bar>
	</span>
</template>

<script>
import firebase from 'firebase/app';
import { mapState } from 'vuex';
export default {
	name: 'AppNavigation',
	data() {
		return {
			appTitle: 'ICBEM 2020',
			drawer: false,
			activeItem: 'Home',
			items: [
				{
					title: 'Home',
					to: '/',
					icon: ['fal', 'home-lg-alt'],
					isActive: false
				},
				{
					title: 'Program',
					to: '/program',
					icon: ['fal', 'calendar-alt'],
					isActive: false
				},
				{
					title: 'Registration',
					to: '/registration-info',
					icon: ['fal', 'door-open'],
					isActive: false
				},
				{
					title: 'Committees',
					to: '/committee',
					icon: ['fal', 'users'],
					isActive: false
				},
				{
					title: 'Speakers',
					to: '/speakers',
					icon: ['fal', 'podium'],
					isActive: false
				},
				{
					title: 'Housing',
					to: '/housing',
					icon: ['fal', 'hotel'],
					isActive: false
				},
				{
					title: 'Past Meetings',
					to: '/past-meetings',
					icon: ['fal', 'history'],
					isActive: false
				},
				{
					title: 'Supporters',
					to: '/supporters',
					icon: ['fal', 'life-ring'],
					isActive: false
				},
				{
					title: 'Updates',
					to: '/updates',
					icon: ['fal', 'inbox-in'],
					isActive: false
				},
				{
					title: 'General Info',
					to: '/general',
					icon: ['fal', 'newspaper'],
					isActive: false
				},
				{
					title: 'Covid Policy',
					to: '/covid-policy',
					icon: ['fal', 'head-side-mask'],
					isActive: false
				}
			],
			authMenuItemsAdmin: [
				{
					title: 'Account',
					to: '/account',
					visible: true,
					enabled: true,
					method: this.noOp
				},
				{
					title: 'Admin',
					to: '/admin',
					visible: true,
					enabled: true,
					method: this.noOp
				},
				{
					title: 'Logout',
					to: '/login',
					visible: true,
					enabled: this.logoutDisabled,
					method: this.logout
				}
			],
			authMenuItemsNonAuthed: [
				{
					title: 'Login',
					to: '/login',
					visible: true,
					enabled: true,
					method: this.noOp
				}
			],
			authMenuItemsNonAdmin: [
				{
					title: 'Account',
					to: '/account',
					visible: true,
					enabled: true,
					method: this.noOp
				},
				{
					title: 'Logout',
					to: '/login',
					visible: true,
					enabled: this.logoutDisabled,
					method: this.logout
				}
			],
			isAuthenticated: firebase.auth().currentUser !== null,
			isAdmin: this.$store.getters.user.admin,
			dropMenuItemsAdmin: [
				{
					title: 'Account',
					to: '/account',
					visible: true,
					enabled: true,
					method: this.noOp
				},
				{
					title: 'Admin',
					to: '/admin',
					visible: true,
					enabled: true,
					method: this.noOp
				},
				{
					title: 'Logout',
					to: '/login',
					visible: true,
					enabled: this.logoutDisabled,
					method: this.logout
				}
			],
			dropMenuItemsNonAuthed: [
				{
					title: 'Login',
					to: '/login',
					visible: true,
					enabled: true,
					method: this.noOp
				}
			],
			dropMenuItemsNonAdmin: [
				{
					title: 'Account',
					to: '/account',
					visible: true,
					enabled: true,
					method: this.noOp
				},
				{
					title: 'Logout',
					to: '/login',
					visible: true,
					enabled: this.logoutDisabled,
					method: this.logout
				}
			],
			accountNav: {
				to: '/account',
				icon: 'fal fa-user-circle',
				isActive: false
			}
		};
	},
	computed: mapState(['user']),
	created() {
		firebase.auth().onAuthStateChanged(() => {
			this.isAuthenticated = firebase.auth().currentUser !== null;
			this.isAdmin = this.$store.getters.user.admin;
		});
		this.unsubscribe = this.$store.subscribe((mutation, state) => {
			if (mutation.type === 'SET_ADMIN') {
				this.isAdmin = state.user.admin;
			}
		});
	},
	beforeDestroy() {
		this.unsubscribe();
	},
	methods: {
		// Checks auth state and directs to account or login page
		// TODO - Remove
		setAccountNavRoute: function() {
			return '/account';
		},
		setLogoutNavEnabledState: function() {
			return this.$store.user ? true : false;
		},
		setAdminNavState: function() {
			return this.$store.user ? this.$store.user.admin : false;
		},
		// Set active state of the current menu item
		setActive: function(item) {
			this.activeItem = item.title;
		},
		isActive: function(item) {
			return this.activeItem === item.title;
		},
		noOp: function() {},
		logout: function() {
			firebase.auth().signOut();
			this.$store.dispatch('setAdmin', false);
			this.$store.dispatch('setAuthenticated', false);
		},
		menuEventHandler: function(menuItem) {
			if (menuItem == 'Logout') {
				this.logout();
			}
		}
	}
};
</script>
<style scoped>
.v-toolbar {
	background: var(--background-color-1);
}
.toolbar-wrapper {
	width: 82%;

	.container {
		max-width: 1300px;
	}
}
.toolbar-link {
	text-align: center;
	padding: 8px;
	font-size: 1vw;
}
.toolbar-link:hover {
	border-top: 2px solid var(--text-color-accent);
}
.active,
.active:hover {
	border: #f5f5f5 solid 1px;
}
.v-toolbar__title {
	font-family: 'Josefin Sans', sans-serif;
	font-size: 1.5rem;
	margin-right: 32px;
}
.logo {
	font-family: 'Josefin Sans', sans-serif;
	font-size: 1.7rem;
	padding-left: 16px;
	width: 400px;
	color: var(--white);
}
.v-toolbar__content a {
	font-family: 'Montserrat', sans-serif;
	color: #f5f5f5;
}
.app-navigation-drawer {
	background: var(--slate);
	color: #f5f5f5;
	font-family: 'Montserrat', sans-serif;
}
.dropdown-trigger-icon path {
	color: var(--white) !important;
}
.v-application a {
	color: #f5f5f5;
}
.v-list__tile__content a {
	color: var(--white);
}
.v-btn .v-btn__content .v-icon {
	color: #f5f5f5;
}
.fal {
	padding-right: 16px;
	color: #f5f5f5;
}
.dropdown-text {
	padding-left: 16px;
}
.account-link {
	text-align: center;
	padding: 8px;
}
.account-nav-icon {
	padding-left: 8px;
	font-size: 2rem;
	color: var(--text-color-accent);
}
.account-nav-menu-item {
	font-family: 'Montserrat', sans-serif;
	color: #f5f5f5;
}
.account-nav-menu {
	background: var(--slate);
}
@media only screen and (max-width: 1600px) {
}
</style>
